import React, {
  useEffect, useState,
} from 'react';

export const useIntersectionObserver = (ref: React.MutableRefObject<any | undefined>, rootMargin?: string, threshold?: number | number[]): boolean => {
  const [visible, setVisibility] = useState(false);

  useEffect(() => {
    let currentRef: Element | null = null;
    const observer = new IntersectionObserver(
      ([entry]) => {
        setVisibility(entry.isIntersecting);
      },
      {
        rootMargin: rootMargin ?? '0px',
        threshold: threshold ?? 0,
      },
    );
    if (ref.current) {
      currentRef = ref.current;
      observer.observe(currentRef as Element);
    }

    return () => {
      observer.unobserve(currentRef as Element);
    };
  }, [ref.current]);

  return visible;
};
